import React from 'react';
import CallOut from '../components/CallOut';
import type {
  AuthenticationMode,
  ProvisionType,
} from '../graphql/generated/graphql';

interface SSOBannerProps {
  provisionType?: ProvisionType | null;
  authenticationSetting?: AuthenticationMode | null;
}

const SSOBanner = ({
  provisionType,
  authenticationSetting,
}: SSOBannerProps) => {
  if (authenticationSetting === 'SSO_ONLY') {
    return (
      <CallOut>Your team requires all invitees to sign up through SSO.</CallOut>
    );
  }

  if (
    authenticationSetting === 'SSO_AND_GUEST_PASSWORD' &&
    (!provisionType || provisionType !== 'GUEST')
  ) {
    return (
      <CallOut>
        Your team requires all new non-guest invitees to sign up through SSO.
      </CallOut>
    );
  }

  return null;
};

export default SSOBanner;
